import { useAcceptCueingChecklist } from '@/api/mutations/procedures';
import { fetchProcedureCueingBlocks } from '@/api/queries/cueing';
import { getProcedureQueryOptions } from '@/api/queries/procedures';
import { getSubjectQueryOptions } from '@/api/queries/subjects';
import { CueingBlockStatus } from '@/api/schema/cueing';
import { BasicInformation } from '@/components/dashboard/basicInformation';
import { Checklist } from '@/components/dashboard/checklist';
import { CueingProfile } from '@/components/dashboard/cueingProfile';
import { StartPanel } from '@/components/dashboard/startPanel';
import { Header } from '@/components/header';
import { Route as ProcedureRoute } from '@/routes/_operator/subjects/$subjectId/procedures/$procedureId/procedure';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_operator/subjects/$subjectId/procedures/$procedureId/')({
  beforeLoad: async ({ params, search }) => {
    const { procedureId } = params as { procedureId: string };
    const blocks = await fetchProcedureCueingBlocks(procedureId);
    const hasStarted = blocks.items.some(b => b.status !== CueingBlockStatus.NOT_STARTED);
    if (hasStarted) {
      redirect({ to: ProcedureRoute.to, params, search, throw: true });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();

  const { subjectId, procedureId } = params as { subjectId: string; procedureId: string };
  const { data: procedure } = useSuspenseQuery(getProcedureQueryOptions(procedureId));
  const { data: subject } = useSuspenseQuery(getSubjectQueryOptions(subjectId));
  const acceptCueingChecklistMutation = useAcceptCueingChecklist();

  const onChecklistAccepted = () => {
    acceptCueingChecklistMutation.mutate({ procedureId });
  };

  return (
    <div>
      <Header />
      <div className="grid grid-cols-2 gap-space-lg pt-lg">
        <div className="flex flex-col gap-space-lg">
          <BasicInformation subjectDetails={ subject } />
          <CueingProfile studyProfile={ subject.studyProfile } />
        </div>
        { procedure.isCueingChecklistAccepted
          ? <StartPanel />
          : (
            <Checklist
              onSuccess={ onChecklistAccepted }
              procedureId={ procedureId }
            />
          ) }
      </div>
    </div>
  );
}
